import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import { emptyWishlist } from 'Redux/ducks/wishlist';
import store from 'Redux/store';

import 'Components/Account/AccountModal.scss';

export default function WishlistEmptyModal({ setOpen }) {
  const emptyAndClose = async (e) => {
    e.preventDefault();
    await store.dispatch(emptyWishlist());
    setOpen(false);
  };

  const toggle = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div className="account-modal-title">
        <FormattedMessage id="deletewishlist.clear" defaultMessage="Delete Wishlist" />
      </div>

      <div className="account-modal-form">
        <p className="account-modal-paragraph">
          <FormattedMessage
            id="deletewishlist.text"
            defaultMessage="You are about to remove all items from your Wishlist."
          />
        </p>
        <p className="account-modal-paragraph mb-0">
          <FormattedMessage
            id="deletewishlist.warning"
            defaultMessage="This cannot be undone. Are you sure?"
          />
        </p>

        <div className="account-modal-form-buttons">
          <div className="form-button-container">
            <Button
              block
              disabled={false}
              color="primary"
              size="lg"
              tag={'button'}
              onClick={e => emptyAndClose(e)}
            >
              <FormattedMessage id="deletewishlist.deletemywishlist" defaultMessage="Delete my Wishlist" />
            </Button>
          </div>
          <div className="form-button-container">
            <Button
              block
              disabled={false}
              color="secondary"
              size="lg"
              tag={'button'}
              onClick={e => toggle(e)}
            >
              <FormattedMessage id="deletewishlist.cancel" defaultMessage="Cancel" />
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

WishlistEmptyModal.propTypes = {
  setOpen: PropTypes.func,
};

WishlistEmptyModal.defaultProps = {
  setOpen: () => {},
};
